import Plausible from 'plausible-tracker';
// set to true to track pageviews and events in dev
let trackLocalhost = false;
let apiHost = 'https://plausible.io';
export function setupPlausible(trackPageViewOnly = false) {
    const el = document.querySelector('[data-plausible-domain]');
    if (el) {
        const steadyDomain = el.dataset.plausibleDomain;
        const publicationDomain = el.dataset.plausiblePublicationDomain || steadyDomain;
        const domain = trackPageViewOnly ? publicationDomain : steadyDomain;
        // el.dataset.plausible* are used in integration tests
        if (el.dataset.plausibleTracklocalhost) {
            trackLocalhost = !!el.dataset.plausibleTracklocalhost;
        }
        if (el.dataset.plausibleApihost) {
            apiHost = el.dataset.plausibleApihost;
        }
        return Plausible({ domain, trackLocalhost, apiHost });
    }
    else {
        return {
            trackPageview: () => { },
            trackEvent: () => { }
        };
    }
}
window.up.compiler('[data-plausible-domain]', () => {
    const { trackPageview } = setupPlausible(true);
    trackPageview();
});
// Plausible automatically tracks UTM parameters in URLs but only when a new session starts
// to track page visits within the site with additional data, we need custom events with props
window.up.compiler('.js-track_click', element => {
    const { trackEvent } = setupPlausible();
    const eventName = element.dataset.trackClickEventName;
    const props = (element.dataset.trackClickProps && JSON.parse(element.dataset.trackClickProps)) || {};
    if (!eventName) {
        // eslint-disable-next-line no-console
        console.error('Missing data attribute trackClickEventName on element', element);
        return;
    }
    // instant links are followed on mousedown, so a click event in never triggered on them
    const event = element.getAttribute('up-instant') ? 'mousedown' : 'click';
    window.up.on(element, event, undefined, function () {
        trackEvent(eventName, { props });
    });
});
window.up.compiler('*[data-track-click-event-name]:not(.js-track_click, .js-track_submit)', element => {
    // eslint-disable-next-line no-console
    console.error('Missing class js-track_click or js-track_submit on element with data attribute trackClickEventName', element);
});
window.up.compiler('.js-track_submit', form => {
    const { trackEvent } = setupPlausible();
    const eventName = form.dataset.trackClickEventName;
    const props = (form.dataset.trackClickProps && JSON.parse(form.dataset.trackClickProps)) || {};
    if (!eventName) {
        // eslint-disable-next-line no-console
        console.error('Missing data attribute trackClickEventName on form', form);
        return;
    }
    window.up.on(form, 'submit', undefined, function () {
        trackEvent(eventName, { props });
    });
});
window.up.compiler('.js-track_page_event', element => {
    const { trackEvent } = setupPlausible();
    const eventName = element.dataset.trackPageEventName;
    const props = (element.dataset.trackPageProps && JSON.parse(element.dataset.trackPageProps)) || {};
    if (!eventName) {
        // eslint-disable-next-line no-console
        console.error('Missing data attribute trackPageEventName on element', element);
        return;
    }
    trackEvent(eventName, { props });
});
